import React, { useState, useEffect } from "react";

const ImpactStats = () => {
  const stats = [
    { number: 5, label: "Years of Service" },
    { number: 20, label: "Schools Supported"},
    { number: 5000, label: "Students Impacted"},
    { number: 100, label: "Educational Programs"}
  ];

  const [animatedStats, setAnimatedStats] = useState(stats.map(stat => ({ ...stat, animatedNumber: 0 })));
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasAnimated) {
          setHasAnimated(true);
          
          // Animate all counters together
          const duration = 5000; // Faster animation (0.8 seconds)
          const startTime = Date.now();
          
          const updateAllCounters = () => {
            const currentTime = Date.now();
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            
            // Easing function for smooth animation
            const easeOutQuart = 1 - Math.pow(1 - progress, 4);
            
            setAnimatedStats(prev => 
              prev.map(stat => ({
                ...stat,
                animatedNumber: Math.floor(easeOutQuart * stat.number)
              }))
            );
            
            if (progress < 1) {
              requestAnimationFrame(updateAllCounters);
            }
          };
          
          requestAnimationFrame(updateAllCounters);
        }
      },
      { threshold: 0.3 }
    );

    const element = document.querySelector('.impact-stats');
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [hasAnimated]);

  // Format numbers with commas
  const formatNumber = (num) => {
    return num.toLocaleString('en-US');
  };

  return (
    <div className="impact-stats" data-aos="fade-up">
      <h2 data-aos="fade-down" data-aos-delay="100">
        Our Impact
      </h2>
      <div className="stats-grid">
        {animatedStats.map((stat, index) => (
          <div 
            key={index} 
            className="stat-card"
            data-aos="zoom-in"
            data-aos-delay={150 + (index * 50)} // Reduced delay for faster appearance
          >
            <div className="stat-icon">{stat.icon}</div>
            <span className="stat-number counter-animated">
              {formatNumber(stat.animatedNumber)}
            </span>
            <span className="stat-label">{stat.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImpactStats;